import { ReduxModel } from '.';
import { setCompany } from '../store/app';
import { updateCompany } from '../utils/api/companies';

class Company<Prop = any> extends ReduxModel {
  storeAction = setCompany;
  storePath = 'app.company';

  update = async (updates: Partial<Prop>) => {
    const { data } = await updateCompany(this.props?.id, updates);

    this.updateStore(data.company);

    return data.company;
  };
}

export default Company;
